import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateChildFn, CanActivateFn, Router } from '@angular/router';

import { Observable, of, switchMap, tap } from 'rxjs';
import { AuthService } from '../../../../core/services/authService';

let isAuthenticated = false;
export const AuthGuard: CanActivateFn | CanActivateChildFn = (route, state) => {
  const redirectUrl = state.url === '/sign-out' ? '/' : state.url;
  let token = localStorage.getItem('accessToken');
  let data;
  if (token) {
    data = inject(AuthService).getDecodedAccessToken(token);
  }
  if (data == null) {
    return _check(redirectUrl);
  } else {
    return _check(redirectUrl).pipe(
      switchMap((authValue) => {
        return of(authValue && isAuthenticated);
      })
    );
  }
  // Check the authentication status
};

const _check = (redirectURL: any) => {
  const _router = inject(Router);
  const res = inject(AuthService).check();
  return of(res).pipe(
    switchMap((authenticated) => {
      // If the user is not authenticated...
      if (!authenticated) {
        // Redirect to the sign-in page
        _router.navigate(['sign-in'], {
          queryParams: redirectURL === '/dashboard' ? {} : { redirectURL },
        });
        isAuthenticated = false;
        // Prevent the access
        return of(false);
      }
      isAuthenticated = true;

      // Allow the access
      return of(true);
    })
  );
  // a.subscribe((res) => {});
  // return a;
};
const _checkUserLogin = (route: ActivatedRouteSnapshot, url: any, data: any): boolean => {
  const userRole = JSON.parse(data.Roles);
  if (route.data['role']) {
    if (Array.isArray(route.data['role'])) {
      let found = [];
      route.data['role'].forEach((element) => {
        let data = userRole.filter((e: any) => e.Name == element);
        data.length > 0 ? found.push(data) : '';
      });
      if (found.length == route.data['role'].length) {
        return true;
      } else {
        inject(Router).navigate(['home']);
        return false;
      }
    } else if (userRole.filter((e: any) => e.Name == route.data['role']).length == 0) {
      inject(Router).navigate(['home']);
      return false;
    } else {
      return false;
    }
  } else {
    return true;
  }
};
